import { atom } from 'jotai';

/** Open state for the post–practice-trial invite modal (not queue-managed). */
export const practiceInviteTeamModalOpenAtom = atom(false);
